import { getIn } from "formik";
import {
  Grid,
  TextField,
  Typography,
  FormControl,
  InputAdornment,
  FormHelperText,
  Box,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
// Shared input style for all checkout fields (matches Subscribe)
import { shades } from "../../theme";
const checkoutInputSx = {
  minHeight: "36px",
  "& .MuiOutlinedInput-root": {
    minHeight: "36px",
    padding: "3px 4px",
    "& input": {
      fontSize: "1.08rem",
      padding: "13px 150px",

      textAlign: "left",
    },
    "&::placeholder": {
      fontSize: "0.95rem",
      opacity: 1,
      color: "#cccccc",
    },
    "& fieldset": {
      borderColor: shades.neutral[300],
    },
    "&:hover fieldset": {
      borderColor: shades.neutral[400],
    },
  },
  "& .MuiOutlinedInput-input::placeholder": {
    fontSize: "0.95rem",
    opacity: 1,
    color: "#cccccc",
  },
};

const FIELD_CONFIG = [
  {
    name: "firstName",
    label: "First Name",
    placeholder: "your first name",
  },
  {
    name: "lastName",
    label: "Last Name",
    placeholder: "your last name",
  },
  { name: "country", label: "Country", placeholder: "Enter your country" },
  { name: "zipCode", label: "Zip Code", placeholder: "your zip code" },
  {
    name: "street1",
    label: "Street Address",
    placeholder: "your address",
  },
  {
    name: "street2",
    label: "Street Address 2 (optional)",
    placeholder: "Apartment, suite",
  },
  { name: "city", label: "City", placeholder: "Enter your city" },
  { name: "state", label: "State", placeholder: "Enter your state" },
];

// Helper to chunk an array into pairs
function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

const AddressForm = ({
  type,
  values,
  touched,
  errors,
  handleBlur,
  handleChange,
  title,
}) => {
  const formattedName = (field) => `${type}.${field}`;
  const formattedError = (field) =>
    Boolean(
      getIn(touched, formattedName(field)) &&
        getIn(errors, formattedName(field))
    );
  const formattedHelper = (field) =>
    getIn(touched, formattedName(field)) && getIn(errors, formattedName(field));

  return (
    <>
      {title && (
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          sx={{ mb: 3, letterSpacing: "0.12em" }}
        >
          {title}
        </Typography>
      )}
      {/* Add margin before SHIPPING INFORMATION if present */}
      {title === "SHIPPING INFORMATION" && <Box mt={5} />}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        py={4}
      >
        <Grid
          container
          spacing={2}
          sx={{
            width: "auto",
            margin: 0,
            justifyContent: "center",
          }}
        >
          {chunkArray(FIELD_CONFIG, 2).map((pair, rowIdx) =>
            pair.map((field, colIdx) => {
              const value = values[field.name] || "";
              const error = formattedError(field.name);
              const helper = formattedHelper(field.name);
              const touchedField = getIn(touched, formattedName(field.name));
              const showSuccess = touchedField && !error && value.length > 0;
              return (
                <Grid item xs={12} md={6} key={field.name} sx={{ px: 1 }}>
                  <FormControl fullWidth variant="outlined" sx={{ mb: 0 }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      type="text"
                      label={field.label}
                      placeholder={field.placeholder}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={value}
                      name={formattedName(field.name)}
                      error={error}
                      sx={checkoutInputSx}
                      InputProps={{
                        endAdornment: error ? (
                          <InputAdornment position="end">
                            <ErrorOutlineIcon color="error" />
                          </InputAdornment>
                        ) : showSuccess ? (
                          <InputAdornment position="end">
                            <CheckCircleOutlineIcon sx={{ color: "#1fc77a" }} />
                          </InputAdornment>
                        ) : null,
                        style: {
                          textAlign: "center",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontSize: 15,
                          letterSpacing: "0.08em",
                          background: "#fff",
                          px: 0.5,
                        },
                      }}
                    />
                    {(error || showSuccess) && (
                      <FormHelperText
                        sx={{
                          color: error ? "#ff4d4f" : "#1fc77a",
                          textAlign: "left",
                          fontWeight: 500,
                          fontSize: 14,
                          mt: 0.5,
                        }}
                      >
                        {error
                          ? helper || "Error"
                          : showSuccess
                            ? "Looks good!"
                            : ""}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              );
            })
          )}
        </Grid>
      </Box>
    </>
  );
};

export default AddressForm;
